.list {
  width: 100%;
}

.option {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background 0.15s ease;
}

.option:hover {
  border-color: rgba(255, 255, 255, 0.3);
}

.selected {
  border-color: var(--accent-color, #c8ff00);
  background: rgba(255, 255, 255, 0.08);
}

/* One available network: a statement of fact, not a choice — no border, no pointer. */
.badge {
  align-self: flex-start;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
}

.icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}

.badgeIcon {
  width: 20px;
  height: 20px;
  font-size: 11px;
}
